import {
  Button,
  Colors,
  Cross,
  ExplainerIcon,
  ExplainerIconIcon,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import './style.scss'

interface IProps extends Pick<RouteComponentProps, 'history'> {
  open: boolean
  email: string
  sendEmail: () => void
  onClose: () => void
}

interface IState {}

export class VerifyEmailModal extends React.Component<IProps, IState> {
  onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  setActive = (status: boolean) => {
    if (!status) {
      const { onClose } = this.props
      window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
      // window.history.back()

      onClose()
    }
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  render() {
    const { sendEmail, open, email } = this.props

    return (
      <Modal
        active={open}
        setActive={this.setActive}
        x={<Cross size="big" color={Colors.unselected} />}
        baseClassName="wrap"
      >
        <Typography type="title" size="big">
          Email Verification
        </Typography>
        <Typography type="text">
          This ensures you'll be able to safely recover your account in case you
          forget your password
        </Typography>
        <ExplainerIcon icon={<ExplainerIconIcon type="mail" />}>
          <Typography type="text">
            We sent you an email to <a href={`mailto:${email}`}>{email}</a>
          </Typography>
        </ExplainerIcon>
        <Button type="max" color="black" onClick={sendEmail}>
          Resend Email
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/VerifyEmailModal/index.tsx